module.exports = __webpack_public_path__ + "public/StoreIcon/editProfile.svg?dee63307";